export default class LocalizedStringService {

    getValue(localizedString, locale) {
        if (!localizedString) {
            return "";
        }

        if (localizedString[locale]) {
            return localizedString[locale]
        } else {
            if (localizedString.fi) {
                return localizedString.fi
            } else if (localizedString.sv) {
                return localizedString.sv
            } else if (localizedString.en)  {
                return localizedString.en
            } else {
                return "";
            }
        }
    }

    localizedStringEquals(ls1, ls2, locale) {
        return ls1[locale] === ls2[locale];
    }

}